/* src/app/components/loading-component/loading-component.css */
:host {
  display: block;
  perspective: 800px;
}
.loading-card {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--line);
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.12),
      transparent 26%),
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.92) 0%,
      rgba(30, 23, 19, 0.96) 100%);
  border-radius: var(--radius-lg);
  padding: 26px 24px;
  box-shadow: var(--shadow);
  perspective: 900px;
}
.loading-card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.035),
      transparent 26%),
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 40px,
      rgba(212, 175, 55, 0.018) 41px,
      transparent 42px);
}
.loading-card > * {
  position: relative;
  z-index: 1;
}
.loading-frame {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  align-items: center;
  gap: 20px;
}
.loading-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
}
.loading-kicker {
  color: var(--gold);
  font-size: 0.78rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}
h2 {
  margin: 0;
  color: #fbf4df;
  letter-spacing: 0.04em;
  text-align: left;
}
p {
  margin: 0;
  line-height: 1.5;
  color: var(--ink-soft);
  max-width: 40ch;
  text-align: left;
}
.loading-flavor {
  margin-top: 4px;
  color: #fbf4df;
  font-size: clamp(1rem, 0.95rem + 0.8vw, 1.4rem);
  font-style: italic;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: 0.02em;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.28);
  max-width: none;
  overflow-wrap: anywhere;
  text-wrap: balance;
}
.loader-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto;
}
.loader-wrapper::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 76px;
  height: 18px;
  transform: translateX(-50%);
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(8, 6, 6, 0.42) 0%,
      rgba(8, 6, 6, 0) 72%);
  animation: dice-shadow 2.5s infinite ease-in-out;
}
.dice {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  animation: spin 2.5s infinite ease-in-out;
}
.face {
  position: absolute;
  width: 120px;
  height: 120px;
  background:
    linear-gradient(
      160deg,
      #f8efcf 0%,
      #dec98d 100%);
  border: 4px solid #8b6d28;
  border-radius: 18px;
  box-sizing: border-box;
  box-shadow: inset 0 0 18px rgba(255, 248, 220, 0.38), 0 0 0 1px rgba(240, 215, 122, 0.16);
}
.dot {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #5a2116;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(90, 33, 22, 0.16);
}
.front {
  transform: rotateY(0deg) translateZ(60px);
}
.back {
  transform: rotateY(180deg) translateZ(60px);
}
.right {
  transform: rotateY(90deg) translateZ(60px);
}
.left {
  transform: rotateY(-90deg) translateZ(60px);
}
.top {
  transform: rotateX(90deg) translateZ(60px);
}
.bottom {
  transform: rotateX(-90deg) translateZ(60px);
}
.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.top-left {
  top: 20px;
  left: 20px;
}
.top-right {
  top: 20px;
  right: 20px;
}
.middle-left {
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
}
.middle-right {
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}
.bottom-left {
  bottom: 20px;
  left: 20px;
}
.bottom-right {
  bottom: 20px;
  right: 20px;
}
@keyframes spin {
  0% {
    transform: rotateX(0deg) rotateY(0deg);
  }
  25% {
    transform: rotateX(90deg) rotateY(180deg);
  }
  50% {
    transform: rotateX(180deg) rotateY(270deg);
  }
  75% {
    transform: rotateX(270deg) rotateY(360deg);
  }
  100% {
    transform: rotateX(360deg) rotateY(540deg);
  }
}
@keyframes dice-shadow {
  0%, 100% {
    transform: translateX(-50%) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateX(-50%) scale(0.82);
    opacity: 0.16;
  }
}
@media (max-width: 640px) {
  .loading-frame {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
  }
  .loading-copy {
    align-items: center;
  }
  h2,
  p {
    text-align: center;
  }
}
/*# sourceMappingURL=loading-component.css.map */
